<template>
  <v-app>
      <v-row no-gutters>
          <v-col md="12" class="no-space">
              <web-2-case v-if="!hideWeb2case"></web-2-case>
              <router-view></router-view>
          </v-col>
      </v-row>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
  computed: {
    hideWeb2case() {
      return this.$route.path.startsWith('/consent')
    }
  },
};
</script>
<style scoped>
.no-space
{
  margin:0;
  padding: 0;
}
</style>
